import React, { useState, useEffect } from "react";
import Backdrop from "../../components/Backdrop";
import Meta from "../../components/Meta";
import SimpleForm from "../../components/chatbot/SimpleForm";
import "./homePage.css";
import { Scroll } from "../../components/Scroll function/scroll";
import stars from "../../Assets/newAsset/newAppStars.webp";
// import FAQforhomepage from "./FAQforhomepage";
// import HealthRisk from "../../components/Plan-detail/HealthRisk";
import { getPackageList } from "../../Redux/Actions";
import { useDispatch, useSelector } from "react-redux";
import loadable from "@loadable/component";
import HowItWorks from "./howItWorks";
import NewHeader from "../../components/NewHeader/NewHeader";
import Slider from "./Components/Slider";
import SliderMobile from "./Components/SliderMobile";
import Content1 from "./Components/Content";
import LaboratoryComponent from "./Components/LaboratoryComponent";
import WhyUsComponent from "./Components/WhyUs";
import DownloadApp from "../../components/DownloadApp/DownloadApp";
import ContactUsNew from "./Components/ContactUsNew";
import Featured from "./Components/Featured";
import FAQforhomepage from "./FAQforhomepage";
// import ScrolltoTop from "../../components/Scrolltotop/ScrolltoTop";
import Footer from "../../components/Footer/Footer";
import SubFooter from "../../components/SubFooter/SubFooter";
// import PopularTests from "./Components/PopularTests";
import CityWiseTest from "./Components/CityWiseTest";
import Modal from "react-responsive-modal";
import Popup from "../../components/PopupNotification/Popup";
import Myhealth from "../Myhealth/Myhealth";

/* Lazy load components starts */

// const NewHeader = loadable(
//   () =>
//     new Promise((resolve, reject) =>
//       setTimeout(() => resolve(import("../../components/NewHeader/NewHeader")))
//     ),
//   {
//     fallback: "loading...",
//   }
// );

// const TopNav = loadable(
//   () =>
//     new Promise((resolve, reject) =>
//       setTimeout(() => resolve(import("../../components/TopNav/TopNav")))
//     ),
//   {
//     fallback: "loading...",
//   }
// );

// const Header = loadable(
//   () =>
//     new Promise((resolve, reject) =>
//       setTimeout(() => resolve(import("../../components/Header/Header")))
//     ),
//   {
//     fallback: "loading...",
//   }
// );

// const Slider = loadable(
//   () =>
//     new Promise((resolve, reject) =>
//       setTimeout(() => resolve(import("./Components/Slider")))
//     ),
//   {
//     fallback: "loading...",
//   }
// );

// const SliderMobile = loadable(
//   () =>
//     new Promise((resolve, reject) =>
//       setTimeout(() => resolve(import("./Components/SliderMobile")))
//     ),
//   {
//     fallback: "loading...",
//   }
// );
// const Content1 = loadable(
//   () =>
//     new Promise((resolve, reject) =>
//       setTimeout(() => resolve(import("./Components/Content")))
//     ),
//   {
//     fallback: "loading...",
//   }
// );
// const Content2 = loadable(
//   () =>
//     new Promise((resolve, reject) =>
//       setTimeout(() => resolve(import("./Components/Content")))
//     ),
//   {
//     fallback: "loading...",
//   }
// );
// const LaboratoryComponent = loadable(
//   () =>
//     new Promise((resolve, reject) =>
//       setTimeout(() => resolve(import("./Components/LaboratoryComponent")))
//     ),
//   {
//     fallback: "loading...",
//   }
// );
// const Apointment = loadable(
//   () =>
//     new Promise((resolve, reject) =>
//       setTimeout(() => resolve(import("./Components/Apointment")))
//     ),
//   {
//     fallback: "loading...",
//   }
// );
// const Content3 = loadable(
//   () =>
//     new Promise((resolve, reject) =>
//       setTimeout(() => resolve(import("./Components/Content")))
//     ),
//   {
//     fallback: "loading...",
//   }
// );
// const ContactUsNew = loadable(
//   () =>
//     new Promise((resolve, reject) =>
//       setTimeout(() => resolve(import("./Components/ContactUsNew")))
//     ),
//   {
//     fallback: "loading...",
//   }
// );
// const Featured = loadable(
//   () =>
//     new Promise((resolve, reject) =>
//       setTimeout(() => resolve(import("./Components/Featured")))
//     ),
//   {
//     fallback: "loading...",
//   }
// );
// const Content4 = loadable(
//   () =>
//     new Promise((resolve, reject) =>
//       setTimeout(() => resolve(import("./Components/Content")))
//     ),
//   {
//     fallback: "loading...",
//   }
// );
// const Content5 = loadable(
//   () =>
//     new Promise((resolve, reject) =>
//       setTimeout(() => resolve(import("./Components/Content")))
//     ),
//   {
//     fallback: "loading...",
//   }
// );
// const FAQforhomepage = loadable(
//   () =>
//     new Promise((resolve, reject) =>
//       setTimeout(() => resolve(import("./FAQforhomepage")))
//     ),
//   {
//     fallback: "loading...",
//   }
// );
// const ScrolltoTop = loadable(
//   () =>
//     new Promise((resolve, reject) =>
//       setTimeout(() =>
//         resolve(import("../../components/Scrolltotop/ScrolltoTop"))
//       )
//     ),
//   {
//     fallback: "loading...",
//   }
// );
// const Footer = loadable(
//   () =>
//     new Promise((resolve, reject) =>
//       setTimeout(() => resolve(import("../../components/Footer/Footer")))
//     ),
//   {
//     fallback: "loading...",
//   }
// );
// const SubFooter = loadable(
//   () =>
//     new Promise((resolve, reject) =>
//       setTimeout(() => resolve(import("../../components/SubFooter/SubFooter")))
//     ),
//   {
//     fallback: "loading...",
//   }
// );
//const Slider = React.lazy(() => import("./Components/Slider"));
/* Lazy load components closed */

const HomePage = () => {
  const [homeimage, setHomeImage] = useState(false);
  const [width, setWidth] = useState("");
  const [open, setOpen] = useState(false);
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);

  useEffect(() => {
    function updateSize() {
      if (typeof window !== "undefined") {
        setWidth(window.screen.width);
      }
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  const dispatch = useDispatch();
  //CALLING ACTION FOR PACKAGE DATA

  // useEffect(() => {
  //   console.log('api calling')
  //   dispatch(getPackageList());
  // });
  const [showModal, setShowModal] = useState(false);
  //CALLING ACTION FOR PACKAGE DATA

  const citySelected = useSelector((state) => state.cityOnTopNav);

  useEffect(() => {
    dispatch(getPackageList(1, "", citySelected.citySelect));
  }, []);

  useEffect(() => {
    Scroll();
    window.location.replace("https://redcliffelabs.com/")

  }, []);

  useEffect(() => {
    setTimeout(() => {
      onOpenModal();
    }, 30000);
  }, []);

  useEffect(() => {
    const size = window.screen.width;
    if (size < 468) {
      setHomeImage(true);
    } else {
      setHomeImage(false);
    }
  }, []);

  const FAQ = [
    {
      id: 1,
      title: "What does Redcliffe Labs do? ",
      desc: "Redcliffe Labs is a specialized clinical laboratory where tests are carried out on medical samples to get information about a patient's health for providing precise diagnosis, treatment, and prevention of certain diseases. It is where lab tests are conducted on clinical specimens (also known as a patient sample), such as blood or urine, and the results are analyzed.",
    },
    {
      id: 2,
      title:
        " What is the procedure to book a health package test from Redcliffe Labs?",
      desc: "Redcliffe Labs offers you the fastest way to book a health package test. Here are the simple steps to book a health package test: Visit www.redcliffelabs.com -> Click on Book Now -> Fill your details in the 'Fill Up Form' section -> Enter (Phone,Name,City) ",
    },
    {
      id: 3,
      title: "  What Makes Redcliffe Labs a Better Pathology Lab than others? ",
      desc: "For us, precision care, safe sample collection, timely delivery of reports, and precise reporting of patient results while adhering to health and safety precautions are the cornerstone of our success. ",
    },
    {
      id: 4,
      title: "How much does a full body checkup cost?",
      desc: "The basic cost of a full body checkup at Redcliffe Labs starts at Rs. 699 including the following tests:Complete Hemogram,  Thyroid Tests, Urine Routine & Microscopy, Liver Function Tests , Kidney Function Tests, Lipid Profile Tests ,Apart from this, other health checkups are offered at Redcliffe Labs that include tests to check for other organs and diseases. Depending upon the severity of the patient's medical conditions, a full body checkup may cost up to Rs. 4999. ",
    },
    {
      id: 5,
      title: "Why opt for a full-body test from Redcliffe Labs?",
      desc: "Getting a whole-body checkup from Redcliffe Labs includes health checkups that include tests for diabetes, thyroid, cholesterol, blood pressure, and other medical conditions to prevent future health issues.",
    },
    {
      id: 6,
      title: "Does Redcliffe Labs provide home sample collection? ",
      desc: "Yes. Redcliffe Labs provides home sample collection by following the required safety measures and protocols. ",
    },
    {
      id: 7,
      title: "Who can get tested by Redcliffe Labs?",
      desc: "Redcliffe Labs full body health checkup helps people keep a check on what's going on inside their bodies. Regular health checkups are important to people ranging between 30-40 years of age to get their full-body checkups every two years. Colorectal cancer screening, blood pressure screening and cholesterol screening tests are also offered at Redcliffe Labs specialized labs for people ageing between 40 and 60 years of age. For people above 60 years or above and experiencing certain health conditions, regular health checkups should be done at least once a year. ",
    },
    {
      id: 8,
      title: " Which is the best test for the whole body?",
      desc: "Some of the popular tests for whole body checkups are: RBC count , Platelet count , Haemoglobin , ESR, HbA1C, Creatinine, Uric Acid , Total Cholesterol, Total Protein and others",
    },
    {
      id: 9,
      title: " What precautions can be taken before a health checkup?",
      desc: "Patients are asked to have their food at least 8-10 hours before health checkups as some tests are done on an empty stomach and require fasting of at least 8-10 hours.",
    },
    {
      id: 10,
      title: "Can I drink water before my full body checkup test?",
      desc: "Patients are asked not to eat or drink anything for at least 8-10 hours if they plan to go for a full body checkup test. The patient can take water in some cases to reduce the chances of dehydration. ",
    },
  ];
  

  const FAQScript = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "1. What does Redcliffe Labs do?",
        acceptedAnswer: {
          "@type": "Answer",
          text:
            "Redcliffe Labs is a specialized clinical laboratory where tests are carried out on medical samples to get information about a patient's health for providing precise diagnosis, treatment, and prevention of certain diseases. It is where lab tests are conducted on clinical specimens (also known as a patient sample), such as blood or urine, and the results are analyzed.",
        },
      },
      {
        "@type": "Question",
        name:
          "2. What is the procedure to book a health package test from Redcliffe Labs?",
        acceptedAnswer: {
          "@type": "Answer",
          text:
            "Redcliffe Labs offers you the fastest way to book a health package test. Here are the simple steps to book a health package test: 1. Visit www.redcliffelabs.com 2. Click on Book Now 3. Fill your details in the Fill Up Form section  - Enter Name - Enter Phone  - Enter City 4. Click on Send a Request You will get a call from our customer support executive who will explain all the details regarding the health package needs. You can also call us at 898 898 8787.",
        },
      },
      {
        "@type": "Question",
        name:
          "3. What Makes Redcliffe Labs a Better Pathology Lab than others?",
        acceptedAnswer: {
          "@type": "Answer",
          text:
            "For us, precision care, safe sample collection, timely delivery of reports, and precise reporting of patient results while adhering to health and safety precautions are the cornerstone of our success.",
        },
      },
      {
        "@type": "Question",
        name: "4. How much does a full body checkup cost?",
        acceptedAnswer: {
          "@type": "Answer",
          text:
            "The basic cost of a full body checkup at Redcliffe Labs starts at Rs. 699 including the following tests: Complete Hemogram Thyroid Tests Urine Routine & Microscopy Liver Function Tests Kidney Function Tests Lipid Profile Tests Apart from this, other health checkups are offered at Redcliffe Labs that include tests to check for other organs and diseases. Depending upon the severity of the patient's medical conditions, a full body checkup may cost up to Rs. 4999.",
        },
      },
      {
        "@type": "Question",
        name: "5. Why opt for a full-body test from Redcliffe Labs?",
        acceptedAnswer: {
          "@type": "Answer",
          text:
            "Getting a whole-body checkup from Redcliffe Labs includes health checkups that include tests for diabetes, thyroid, cholesterol, blood pressure, and other medical conditions to prevent future health issues.",
        },
      },
      {
        "@type": "Question",
        name: "6. Does Redcliffe Labs provide home sample collection?",
        acceptedAnswer: {
          "@type": "Answer",
          text:
            "Yes. Redcliffe Labs provides home sample collection by following the required safety measures and protocols.",
        },
      },
      {
        "@type": "Question",
        name: "7. Who can get tested by Redcliffe Labs?",
        acceptedAnswer: {
          "@type": "Answer",
          text:
            "Redcliffe Labs full body health checkup helps people keep a check on what's going on inside their bodies. Regular health checkups are important to people ranging between 30-40 years of age to get their full-body checkups every two years. Colorectal cancer screening, blood pressure screening and cholesterol screening tests are also offered at Redcliffe Labs specialized labs for people ageing between 40 and 60 years of age. For people above 60 years or above and experiencing certain health conditions, regular health checkups should be done at least once a year.",
        },
      },
      {
        "@type": "Question",
        name: "8. Which is the best test for the whole body?",
        acceptedAnswer: {
          "@type": "Answer",
          text:
            "Some of the popular tests for whole body checkups are: RBC count Platelet count Haemoglobin ESR HbA1C Creatinine Uric Acid Total Cholesterol Total Protein and others",
        },
      },
      {
        "@type": "Question",
        name: "9. What precautions can be taken before a health checkup?",
        acceptedAnswer: {
          "@type": "Answer",
          text:
            "Patients are asked to have their food at least 8-10 hours before health checkups as some tests are done on an empty stomach and require fasting of at least 8-10 hours.",
        },
      },
      {
        "@type": "Question",
        name: "10. Can I drink water before my full body checkup test?",
        acceptedAnswer: {
          "@type": "Answer",
          text:
            "Patients are asked not to eat or drink anything for at least 8-10 hours if they plan to go for a full body checkup test. The patient can take water in some cases to reduce the chances of dehydration.",
        },
      },
    ],
  };
  const jsonMeta = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: " Redcliffe Labs ",
    url: "https://redcliffelabs.com/",
    logo:
      "https://staticcdn.redcliffelabs.com/media/gallary-file/None/a0f82e2b-5cee-4694-a972-2514e9bd3694.svg",
    address: {
      "@type": "PostalAddress",
      streetAddress: "H55  , Electronic City, Noida, Uttar Pradesh 201301",
      addressLocality: "Electronic City, Noida",
      addressRegion: "Noida, Uttar Pradesh",
      postalCode: "201301",
      addressCountry: "India",
    },
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "contact",
      telephone: "898 898 8787",
      email: "care@redcliffelabs.com",
    },
    sameAs: [
      "https://www.instagram.com/redcliffelabs/",
      "https://www.facebook.com/RedcliffeLabs/",
      "https://twitter.com/redcliffelab",
      "https://www.linkedin.com/company/redcliffe-labs/",
      "https://www.youtube.com/c/RedcliffeLabs",
    ],
  };

  let googleLogo =
    "https://staticcdn.redcliffelabs.com/media/gallary-file/None/33507b7b-3dc2-4ef8-b7ef-572d177f5216.png";

  //import banner1 from "../../../Assets/newAsset/mobileSlider/500banner1.png";
  return (
    <React.Fragment>
      <Meta
        title="Redcliffe Labs, a Leading Diagnostic Centre in India - Redcliffe Labs"
        description="Redcliffe Labs is one of the best diagnostic centres & diagnosis labs in India that provides Full body Checkup at Home, Blood Test Online with Free Sample Collection and Free Doctor Consultation - Redcliffe Labs."
      >
        <link rel="canonical" href="https://redcliffelabs.com/"></link>
        <meta
          property="og:title"
          content="Redcliffe Labs: Leading Diagnostic Centre in India"
        />
        <script type="application/ld+json">{JSON.stringify(jsonMeta)}</script>
        <script type="application/ld+json">{JSON.stringify(FAQScript)}</script>
        <meta property="og:site_name" content="Redcliffe Labs" />
        <meta property="og:url" content="https://redcliffelabs.com/" />
        <meta
          property="og:description"
          content="Redcliffe Labs is one of the best diagnostic centres & diagnosis labs in India that provides Full body Checkup at Home, Blood Test Online with Free Sample Collection and Free Doctor Consultation - Redcliffe Labs."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://redcliffelabs.com/OG-Twitter-Card.jpg"
        />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@Redcliffe_Labs" />
        <meta
          name="twitter:title"
          content="Redcliffe Labs: Leading Diagnostic Centre in India"
        />
        <meta
          name="twitter:description"
          content="Redcliffe Labs is one of the best diagnostic centres & diagnosis labs in India that provides Full body Checkup at Home, Blood Test Online with Free Sample Collection and Free Doctor Consultation - Redcliffe Labs."
        />
        <meta
          name="twitter:image"
          content="https://redcliffelabs.com/OG-Twitter-Card.jpg"
        />
      </Meta>
      {showModal && (
        <React.Fragment>
          <Backdrop setShowModal={setShowModal} />
        </React.Fragment>
      )}
      <NewHeader faq={true} />
      {width <= 780 ? (
        <div className=" mobileSlider">{<SliderMobile />}</div>
      ) : (
        <div className="sliderDesktop ">
          {" "}
          <Slider />
        </div>
      )}

      <Content1
        title="Our Specialities"
        subheading=" All Diagnostic Services Under One Roof"
        Ispackage={false}
      />
      <Content1
        // title="Best Health Check-Up Packages"
        Ispackage={true}
      />
      {/* <HealthRisk /> */}

      {/* <LaboratoryComponent /> */}

      <WhyUsComponent />
      {/* <Apointment img={stars} /> */}
      <HowItWorks />
      {/* <Content1 title="How it works?" Ispackage={false} bgImg={BgImg} /> */}
      <DownloadApp />
      <ContactUsNew
        email="care@redcliffelabs.com"
        telNumber={"898 898 8787"}
        data1={
          "To know more about Redcliffe Labs or our Diagnostic Centre, please get in touch with our dedicated customer care team. Our team is available 7 days a week to assist you with your queries."
        }
      />
      <Content1 title="Gallery" Ispackage={false} isGallery={true} />
      <Featured />
      <Content1
        title="Reviews"
        Ispackage={false}
        isTestimonial={true}
        googleLogo={googleLogo}
      />

      {/* <Content1 title="Blogs" Ispackage={false} isBlog={true} /> */}
      <Myhealth />
      <FAQforhomepage faq={FAQ}/>
      <CityWiseTest />
      <div className="chatbot">
        <SimpleForm />
      </div>

      {/* Notification popup */}
      <Modal
        classNames={{
          overlay: "customOverlay",
          modal: "notificationPopup_modal",
        }}
        open={open}
        onClose={onCloseModal}
        center
      >
        <Popup setOpen={setOpen} />
      </Modal>

      {/* <ScrolltoTop /> */}
      <Footer />
      <SubFooter />
    </React.Fragment>
  );
};

export default {
  component: HomePage,
};
